export const routes = [
    
    {
      path: '/wechat-required',
      name: '请在微信中访问',
      component: () => import('./pages/wx_views/wechat_required.vue'),
      meta: { hideTabbar: true }
    },
    {
      path: '/login',
      name: '登录',
      component: () => import('./pages/wx_views/login/index.vue')
    },
    {
      path: '/login/callback',
      name: '微信登录回调',
      component: () => import('./pages/wx_views/login/callback.vue')
    },
    {
      path: '/login/regist_protocol',
      name: '隐私协议',
      component: () => import('./pages/wx_views/login/regist_protocol.vue')
    },
    {
      path: '/login/regist',
      name: '注册登录',
      component: () => import('./pages/wx_views/login/regist.vue')
    },
    {
      path: '/index',
      name: '首页框架',
      alias: '/',
      component: () => import('./pages/wx_views/index.vue'),
      children: [
        {
          path: '',
          name: '首页默认',
          component: () => import('./pages/wx_views/index/index.vue')
        },
        {
          path: 'home',
          name: '首页内容',
          component: () => import('./pages/wx_views/index/index.vue')
        },
        {
          path: 'my/index',
          alias: '/my/index',
          name: '我的',
          component: () => import('./pages/wx_views/my/index.vue')
        },
        {
          path: 'cert/idCard',
          alias: '/cert/idCard',
          name: '实名认证',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/cert/id_card.vue')
        },
        {
          path: 'cert/fail',
          alias: '/cert/fail',
          name: '认证失败',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/cert/fail.vue')
        },
        {
          path: 'cert/license',
          alias: '/cert/license',
          name: '营业执照认证',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/cert/license.vue')
        },
        {
          path: 'cert/store',
          alias: '/cert/store',
          name: '完善门店资料',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/cert/store.vue')
        },
        {
          path: 'cert/success',
          alias: '/cert/success',
          name: '认证成功',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/cert/success.vue')
        },
        {
          path: 'cert/contract',
          alias: '/cert/contract',
          name: '签署协议',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/cert/constract.vue')
        },
        {
          path: 'order/index',
          alias: '/order/index',
          name: '下单页面',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/order/index.vue')
        },
        {
          path: 'order/index2',
          alias: '/order/index2',
          name: '下单页面2',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/order/index2.vue')
        },
        {
          path: 'agreement/disclaimer',
          alias: '/agreement/disclaimer',
          name: '免责协议',
          meta: { hideTabbar: true },
          component: () => import('./pages/wx_views/agreement/disclaimer.vue')
        },
        {
          path: 'address/index',
          alias: '/address/index',
          name: '地址管理',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/address/index.vue')
        },
        {
          path: 'address/addOrUpdate/:id?',
          alias: '/address/addOrUpdate/:id?',
          name: '地址新增或编辑',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/address/addOrUpdate.vue')
        },
        {
          path: 'my/bank_card/index',
          alias: '/my/bank_card/index',
          name: '银行卡管理',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/bank_card/index.vue')
        },
        {
          path: 'my/bank_card/add',
          alias: '/my/bank_card/add',
          name: '添加银行卡',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/bank_card/add.vue')
        },
        {
          path: 'my/order/index',
          alias: '/my/order/index',
          name: '我的订单',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/order/index.vue')
        },
        {
          path: 'my/order/detail/:id?',
          alias: '/my/order/detail/:id?',
          name: '订单详情',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/order/detail.vue')
        },
        {
          path: 'my/order/edit/:id',
          alias: '/my/order/edit/:id',
          name: '修改订单',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/order/edit.vue')
        },
        {
          path: 'my/order/report/:id',
          alias: '/my/order/report/:id',
          name: '检测报告',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/order/report.vue')
        },
        {
          path: 'my/settings',
          alias: '/my/settings',
          name: '用户设置',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/settings.vue')
        },
        {
          path: 'my/member/index',
          alias: '/my/member/index',
          name: '会员专区',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/member/index.vue')
        },
        {
          path: 'my/member/benefits',
          alias: '/my/member/benefits',
          name: '我的会员权益',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/member/benefits.vue')
        },
        {
          path: 'my/coupon/index',
          alias: '/my/coupon/index',
          name: '优惠券',
          meta: { hideTabbar: true, requiresAuth: true },
          component: () => import('./pages/wx_views/my/coupon/index.vue')
        },
        {
          path: 'price_trend',
          name: '价格趋势',
          meta: { hideTabbar: true },
          component: () => import('./pages/wx_views/index/price_trend.vue')
        },
        {
          path: 'valuation',
          name: '在线估价',
          meta: { hideTabbar: true },
          component: () => import('./pages/wx_views/index/valuation.vue')
        },
        {
          path: 'order/logistics',
          alias: '/order/logistics',
          name: '物流查询',
          meta: { hideTabbar: true },
          component: () => import('./pages/wx_views/my/order/logistics.vue')
        },
      {
        path: 'pdf-preview',
        alias: '/pdf-preview',
        name: 'PDF预览',
        meta: { hideTabbar: true, requiresAuth: true },
        component: () => import('./pages/wx_views/my/order/pdf-preview.vue')
      },
      {
        path: 'my/signature',
        alias: '/my/signature',
        name: '签字确认',
        meta: { hideTabbar: true, requiresAuth: true },
        component: () => import('./pages/wx_views/my/signature/index.vue')
      },
      {
        path: 'my/order/order_contract',
        alias: '/my/order/order_contract',
        name: '订单合同',
        meta: { hideTabbar: true, requiresAuth: true },
        component: () => import('./pages/wx_views/my/order/order_contract.vue')
      },
      {
        path: 'agreement/supplemental_result',
        alias: '/agreement/supplemental_result',
        name: '补充协议签署结果',
        meta: { hideTabbar: true, requiresAuth: true },
        component: () => import('./pages/wx_views/agreement/supplemental_result.vue')
      },

      ]
    },

    {
      path: '/lossless/index',
      name: '无损检测',
      component: () => import('./pages/lossless/index.vue')
    },
    {
      path: '/lossless/lossless_index',
      name: '无损检测',
      component: () => import('./pages/lossless/lossless_index.vue')
    },
    {
      path: '/damage/index',
      name: '有损检测',
      component: () => import('./pages/damage_detection/index.vue')
    },
    {
      path: '/price/index',
      name: '贵金属实时价格',
      component: () => import('./pages/price/index.vue')
    },
    {
      path: '/price/member',
      name: '会员盘价',
      meta: { requiresAuth: true, title: '会员盘价' },
      component: () => import('./pages/price/member-index.vue')
    },
    {
      path: '/price/tv',
      name: '价格显示',
      component: () => import('./pages/price/tv-price.vue')
    },

 
    // 后台管理系统路由
    {
      path: '/admin/login',
      name: '后台登录',
      component: () => import('./pages/admin/login.vue')
    },
    {
      path: '/admin',
      name: '后台管理',
      component: () => import('./pages/admin/index.vue'),
      meta: { requiresAuth: true },
      children: [
        // 保留原有子路由；当访问 /admin 根路径时，将直接展示 index.vue 中的首页内容
        {
          path: 'contract',
          name: '合同管理',
          component: () => import('./pages/admin/contract/index.vue')
        },
        {
          path: 'order',
          name: '订单管理',
          component: () => import('./pages/admin/order/index.vue')
        },
        {
          path: 'order/detail',
          name: '订单信息详情',
          component: () => import('./pages/admin/order/detail.vue')
        },
        {
          path: 'contract/detail',
          name: '合同详情',
          component: () => import('./pages/admin/contract/detail.vue')
        },
        {
          path: 'detection',
          name: '检测记录',
          component: () => import('./pages/admin/detection/index.vue')
        },
        {
          path: 'detection/detail',
          name: '检测详情',
          component: () => import('./pages/admin/detection/detail.vue')
        },
        {
          path: 'receipt',
          name: '结算单管理',
          component: () => import('./pages/admin/receipt/index.vue')
        },
        {
          path: 'receipt/print',
          name: '结算单打印',
          component: () => import('./pages/admin/receipt/print.vue')
        },
      ]
    }
]

export default routes
